import { render, staticRenderFns } from "./StatesButton.vue?vue&type=template&id=2ce1044f&scoped=true&"
import script from "./StatesButton.vue?vue&type=script&lang=js&"
export * from "./StatesButton.vue?vue&type=script&lang=js&"
import style0 from "./StatesButton.vue?vue&type=style&index=0&id=2ce1044f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce1044f",
  null
  
)

export default component.exports